<app-card
  class="flex-basis-100 mb-12"
  *ngIf="hasGeneralInfo(metadata) || hasGeneralInfo(originalMetadata)"
>
  <div cardTitle i18n>Informations générales</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows w-100">
      <div
        class="card__row"
        *ngIf="metadata?.startDate || originalMetadata?.startDate"
      >
        <span class="card__label" i18n>Date de début</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                (originalMetadata?.startDate | customDate) !==
                  (metadata.startDate | customDate),
            }"
            >{{ metadata.startDate | customDate }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              (originalMetadata?.startDate | customDate) !==
                (metadata.startDate | customDate) &&
              (originalMetadata?.startDate | customDate) !== null &&
              (originalMetadata?.startDate | customDate) !== undefined
            "
            >{{ originalMetadata?.startDate | customDate }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.contractDuration || originalMetadata?.contractDuration"
      >
        <span class="card__label" i18n>Durée du contrat</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata?.contractDuration !==
                  metadata.contractDuration,
            }"
            >{{ metadata.contractDuration }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata?.contractDuration !==
                metadata.contractDuration &&
              originalMetadata?.contractDuration !== null &&
              originalMetadata?.contractDuration !== undefined
            "
            >{{ originalMetadata?.contractDuration }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.paymentFrequency !== undefined &&
            metadata?.paymentFrequency !== null) ||
          (originalMetadata?.paymentFrequency !== undefined &&
            originalMetadata?.paymentFrequency !== null)
        "
      >
        <span class="card__label" i18n>Mode de paiement</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                labelPaymentFrequency(originalMetadata?.paymentFrequency) !==
                  labelPaymentFrequency(metadata.paymentFrequency),
            }"
            >{{ labelPaymentFrequency(metadata.paymentFrequency) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              labelPaymentFrequency(originalMetadata?.paymentFrequency) !==
                labelPaymentFrequency(metadata.paymentFrequency) &&
              labelPaymentFrequency(originalMetadata?.paymentFrequency) !==
                null &&
              labelPaymentFrequency(originalMetadata?.paymentFrequency) !==
                undefined
            "
            >{{
              labelPaymentFrequency(originalMetadata?.paymentFrequency)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.splitPaymentFee !== undefined &&
            metadata?.splitPaymentFee !== null) ||
          (originalMetadata?.splitPaymentFee !== undefined &&
            originalMetadata?.splitPaymentFee !== null)
        "
      >
        <span class="card__label" i18n
          >Supplément pour paiement fractionné</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata?.splitPaymentFee !== metadata.splitPaymentFee,
            }"
            >{{ metadata.splitPaymentFee }} %</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata?.splitPaymentFee !== metadata.splitPaymentFee &&
              originalMetadata?.splitPaymentFee !== null &&
              originalMetadata?.splitPaymentFee !== undefined
            "
            >{{ originalMetadata?.splitPaymentFee }} %</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.hasclaimsLastFiveYears !== null &&
            metadata?.hasclaimsLastFiveYears !== undefined) ||
          (originalMetadata?.hasclaimsLastFiveYears !== null &&
            originalMetadata?.hasclaimsLastFiveYears !== undefined)
        "
      >
        <span class="card__label" i18n
          >A subi des sinistres ces 5 dernières années</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(originalMetadata?.hasclaimsLastFiveYears) !==
                  getBooleanLabel(metadata.hasclaimsLastFiveYears),
            }"
            >{{ getBooleanLabel(metadata.hasclaimsLastFiveYears) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(originalMetadata?.hasclaimsLastFiveYears) !==
                getBooleanLabel(metadata.hasclaimsLastFiveYears) &&
              getBooleanLabel(originalMetadata?.hasclaimsLastFiveYears) !==
                null &&
              getBooleanLabel(originalMetadata?.hasclaimsLastFiveYears) !==
                undefined
            "
            >{{
              getBooleanLabel(originalMetadata?.hasclaimsLastFiveYears)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.claims || originalMetadata?.claims"
      >
        <span class="card__label" i18n>Détails des sinistres</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata?.claims !== metadata.claims,
            }"
            >{{ metadata.claims }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata?.claims !== metadata.claims &&
              originalMetadata?.claims !== null &&
              originalMetadata?.claims !== undefined
            "
            >{{ originalMetadata?.claims }}</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>

<app-card
  class="flex-basis-100 mb-12"
  *ngIf="
    !isSectionEmpty(metadata?.thirdPartyDamages) ||
    !isSectionEmpty(originalMetadata?.thirdPartyDamages)
  "
>
  <div cardTitle i18n>Domages de tiers</div>
  <div
    cardRows
    class="card__rows w-100"
    *ngIf="metadata?.thirdPartyDamages || originalMetadata?.thirdPartyDamages"
  >
    <div class="card__rows w-100">
      <div
        class="card__row"
        *ngIf="
          (metadata.thirdPartyDamages.financialLossCivilResponsability !==
            null &&
            metadata.thirdPartyDamages.financialLossCivilResponsability !==
              undefined) ||
          (originalMetadata?.thirdPartyDamages
            .financialLossCivilResponsability !== null &&
            originalMetadata?.thirdPartyDamages
              .financialLossCivilResponsability !== undefined)
        "
      >
        <span class="card__label" i18n>RC pour les préjudices de fortune</span>
        <span class="card__value">{{
          getBooleanLabel(
            metadata.thirdPartyDamages.financialLossCivilResponsability
          )
        }}</span>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata.thirdPartyDamages.insuranceSum !== undefined &&
            metadata.thirdPartyDamages.insuranceSum !== null) ||
          (originalMetadata?.thirdPartyDamages.insuranceSum !== undefined &&
            originalMetadata?.thirdPartyDamages.insuranceSum !== null)
        "
      >
        <span class="card__label" i18n>Somme d'assurance</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata?.thirdPartyDamages.insuranceSum !==
                  metadata.thirdPartyDamages.insuranceSum,
            }"
            >{{ metadata.thirdPartyDamages.insuranceSum }} CHF</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata?.thirdPartyDamages.insuranceSum !==
                metadata.thirdPartyDamages.insuranceSum &&
              originalMetadata?.thirdPartyDamages.insuranceSum !== null &&
              originalMetadata?.thirdPartyDamages.insuranceSum !== undefined
            "
            >{{ originalMetadata?.thirdPartyDamages.insuranceSum }} CHF</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata.thirdPartyDamages.availabilityDamage !== null &&
            metadata.thirdPartyDamages.availabilityDamage !== undefined) ||
          (originalMetadata?.thirdPartyDamages.availabilityDamage !== null &&
            originalMetadata?.thirdPartyDamages.availabilityDamage !==
              undefined)
        "
      >
        <span class="card__label" i18n
          >Atteintes à la disponibilité de systèmes informatiques</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  originalMetadata?.thirdPartyDamages.availabilityDamage
                ) !==
                  getBooleanLabel(
                    metadata.thirdPartyDamages.availabilityDamage
                  ),
            }"
            >{{
              getBooleanLabel(metadata.thirdPartyDamages.availabilityDamage)
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(
                originalMetadata?.thirdPartyDamages.availabilityDamage
              ) !==
                getBooleanLabel(
                  metadata.thirdPartyDamages.availabilityDamage
                ) &&
              getBooleanLabel(
                originalMetadata?.thirdPartyDamages.availabilityDamage
              ) !== null &&
              getBooleanLabel(
                originalMetadata?.thirdPartyDamages.availabilityDamage
              ) !== undefined
            "
            >{{
              getBooleanLabel(
                originalMetadata?.thirdPartyDamages.availabilityDamage
              )
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata.thirdPartyDamages.dataLoss !== null &&
            metadata.thirdPartyDamages.dataLoss !== undefined) ||
          (originalMetadata?.thirdPartyDamages.dataLoss !== null &&
            originalMetadata?.thirdPartyDamages.dataLoss !== undefined)
        "
      >
        <span class="card__label" i18n>Pertes de données</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  originalMetadata?.thirdPartyDamages.dataLoss
                ) !== getBooleanLabel(metadata.thirdPartyDamages.dataLoss),
            }"
            >{{ getBooleanLabel(metadata.thirdPartyDamages.dataLoss) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(originalMetadata?.thirdPartyDamages.dataLoss) !==
                getBooleanLabel(metadata.thirdPartyDamages.dataLoss) &&
              getBooleanLabel(originalMetadata?.thirdPartyDamages.dataLoss) !==
                null &&
              getBooleanLabel(originalMetadata?.thirdPartyDamages.dataLoss) !==
                undefined
            "
            >{{
              getBooleanLabel(originalMetadata?.thirdPartyDamages.dataLoss)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata.thirdPartyDamages.hacking !== null &&
            metadata.thirdPartyDamages.hacking !== undefined) ||
          (originalMetadata?.thirdPartyDamages.hacking !== null &&
            originalMetadata?.thirdPartyDamages.hacking !== undefined)
        "
      >
        <span class="card__label" i18n
          >Intervention illicite dans les systèmes informatiques (Hacking)</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(originalMetadata?.thirdPartyDamages.hacking) !==
                  getBooleanLabel(metadata.thirdPartyDamages.hacking),
            }"
            >{{ getBooleanLabel(metadata.thirdPartyDamages.hacking) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(originalMetadata?.thirdPartyDamages.hacking) !==
                getBooleanLabel(metadata.thirdPartyDamages.hacking) &&
              getBooleanLabel(originalMetadata?.thirdPartyDamages.hacking) !==
                null &&
              getBooleanLabel(originalMetadata?.thirdPartyDamages.hacking) !==
                undefined
            "
            >{{
              getBooleanLabel(originalMetadata?.thirdPartyDamages.hacking)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata.thirdPartyDamages.piracy !== null &&
            metadata.thirdPartyDamages.piracy !== undefined) ||
          (originalMetadata?.thirdPartyDamages.piracy !== null &&
            originalMetadata?.thirdPartyDamages.piracy !== undefined)
        "
      >
        <span class="card__label" i18n>Violation de droits protégés</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(originalMetadata?.thirdPartyDamages.piracy) !==
                  getBooleanLabel(metadata.thirdPartyDamages.piracy),
            }"
            >{{ getBooleanLabel(metadata.thirdPartyDamages.piracy) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(originalMetadata?.thirdPartyDamages.piracy) !==
                getBooleanLabel(metadata.thirdPartyDamages.piracy) &&
              getBooleanLabel(originalMetadata?.thirdPartyDamages.piracy) !==
                null &&
              getBooleanLabel(originalMetadata?.thirdPartyDamages.piracy) !==
                undefined
            "
            >{{
              getBooleanLabel(originalMetadata?.thirdPartyDamages.piracy)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata.thirdPartyDamages.privacyViolation !== null &&
            metadata.thirdPartyDamages.privacyViolation !== undefined) ||
          (originalMetadata?.thirdPartyDamages.privacyViolation !== null &&
            originalMetadata?.thirdPartyDamages.privacyViolation !== undefined)
        "
      >
        <span class="card__label" i18n
          >Violation de la protection des données</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  originalMetadata?.thirdPartyDamages.privacyViolation
                ) !==
                  getBooleanLabel(metadata.thirdPartyDamages.privacyViolation),
            }"
            >{{
              getBooleanLabel(metadata.thirdPartyDamages.privacyViolation)
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(
                originalMetadata?.thirdPartyDamages.privacyViolation
              ) !==
                getBooleanLabel(metadata.thirdPartyDamages.privacyViolation) &&
              getBooleanLabel(
                originalMetadata?.thirdPartyDamages.privacyViolation
              ) !== null &&
              getBooleanLabel(
                originalMetadata?.thirdPartyDamages.privacyViolation
              ) !== undefined
            "
            >{{
              getBooleanLabel(
                originalMetadata?.thirdPartyDamages.privacyViolation
              )
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata.thirdPartyDamages.paymentDataViolation !== null &&
            metadata.thirdPartyDamages.paymentDataViolation !== undefined) ||
          (originalMetadata?.thirdPartyDamages.paymentDataViolation !== null &&
            originalMetadata?.thirdPartyDamages.paymentDataViolation !==
              undefined)
        "
      >
        <span class="card__label" i18n
          >Violation des normes de sécurité des données PCI</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  originalMetadata?.thirdPartyDamages.paymentDataViolation
                ) !==
                  getBooleanLabel(
                    metadata.thirdPartyDamages.paymentDataViolation
                  ),
            }"
            >{{
              getBooleanLabel(metadata.thirdPartyDamages.paymentDataViolation)
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(
                originalMetadata?.thirdPartyDamages.paymentDataViolation
              ) !==
                getBooleanLabel(
                  metadata.thirdPartyDamages.paymentDataViolation
                ) &&
              getBooleanLabel(
                originalMetadata?.thirdPartyDamages.paymentDataViolation
              ) !== null &&
              getBooleanLabel(
                originalMetadata?.thirdPartyDamages.paymentDataViolation
              ) !== undefined
            "
            >{{
              getBooleanLabel(
                originalMetadata?.thirdPartyDamages.paymentDataViolation
              )
            }}</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>

<app-card
  class="flex-basis-100 mb-12"
  *ngIf="
    !isSectionEmpty(metadata?.ownDamages) ||
    !isSectionEmpty(originalMetadata?.ownDamages)
  "
>
  <div cardTitle i18n>Dommages propres</div>
  <div
    cardRows
    class="card__rows w-100"
    *ngIf="metadata?.ownDamages || originalMetadata?.ownDamages"
  >
    <div class="card__rows w-100">
      <div
        class="card__row"
        *ngIf="
          (metadata.ownDamages.malwareRemoval !== null &&
            metadata.ownDamages.malwareRemoval !== undefined) ||
          (originalMetadata?.ownDamages.malwareRemoval !== null &&
            originalMetadata?.ownDamages.malwareRemoval !== undefined)
        "
      >
        <span class="card__label" i18n>Elimination des maliciels</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(originalMetadata?.ownDamages.malwareRemoval) !==
                  getBooleanLabel(metadata.ownDamages.malwareRemoval),
            }"
            >{{ getBooleanLabel(metadata.ownDamages.malwareRemoval) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(originalMetadata?.ownDamages.malwareRemoval) !==
                getBooleanLabel(metadata.ownDamages.malwareRemoval) &&
              getBooleanLabel(originalMetadata?.ownDamages.malwareRemoval) !==
                null &&
              getBooleanLabel(originalMetadata?.ownDamages.malwareRemoval) !==
                undefined
            "
            >{{
              getBooleanLabel(originalMetadata?.ownDamages.malwareRemoval)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata.ownDamages.dataRetrieval !== null &&
            metadata.ownDamages.dataRetrieval !== undefined) ||
          (originalMetadata?.ownDamages.dataRetrieval !== null &&
            originalMetadata?.ownDamages.dataRetrieval !== undefined)
        "
      >
        <span class="card__label" i18n
          >Reconstitution ou récupération des données électroniques</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(originalMetadata?.ownDamages.dataRetrieval) !==
                  getBooleanLabel(metadata.ownDamages.dataRetrieval),
            }"
            >{{ getBooleanLabel(metadata.ownDamages.dataRetrieval) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(originalMetadata?.ownDamages.dataRetrieval) !==
                getBooleanLabel(metadata.ownDamages.dataRetrieval) &&
              getBooleanLabel(originalMetadata?.ownDamages.dataRetrieval) !==
                null &&
              getBooleanLabel(originalMetadata?.ownDamages.dataRetrieval) !==
                undefined
            "
            >{{
              getBooleanLabel(originalMetadata?.ownDamages.dataRetrieval)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata.ownDamages.additionalFees !== null &&
            metadata.ownDamages.additionalFees !== undefined) ||
          (originalMetadata?.ownDamages.additionalFees !== null &&
            originalMetadata?.ownDamages.additionalFees !== undefined)
        "
      >
        <span class="card__label" i18n>Frais supplémentaires</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(originalMetadata?.ownDamages.additionalFees) !==
                  getBooleanLabel(metadata.ownDamages.additionalFees),
            }"
            >{{ getBooleanLabel(metadata.ownDamages.additionalFees) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(originalMetadata?.ownDamages.additionalFees) !==
                getBooleanLabel(metadata.ownDamages.additionalFees) &&
              getBooleanLabel(originalMetadata?.ownDamages.additionalFees) !==
                null &&
              getBooleanLabel(originalMetadata?.ownDamages.additionalFees) !==
                undefined
            "
            >{{
              getBooleanLabel(originalMetadata?.ownDamages.additionalFees)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata.ownDamages.paymentProcessing !== null &&
            metadata.ownDamages.paymentProcessing !== undefined) ||
          (originalMetadata?.ownDamages.paymentProcessing !== null &&
            originalMetadata?.ownDamages.paymentProcessing !== undefined)
        "
      >
        <span class="card__label" i18n>Trafic électronique des paiements</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  originalMetadata?.ownDamages.paymentProcessing
                ) !== getBooleanLabel(metadata.ownDamages.paymentProcessing),
            }"
            >{{ getBooleanLabel(metadata.ownDamages.paymentProcessing) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(
                originalMetadata?.ownDamages.paymentProcessing
              ) !== getBooleanLabel(metadata.ownDamages.paymentProcessing) &&
              getBooleanLabel(
                originalMetadata?.ownDamages.paymentProcessing
              ) !== null &&
              getBooleanLabel(
                originalMetadata?.ownDamages.paymentProcessing
              ) !== undefined
            "
            >{{
              getBooleanLabel(originalMetadata?.ownDamages.paymentProcessing)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata.ownDamages.shippingDamage !== null &&
            metadata.ownDamages.shippingDamage !== undefined) ||
          (originalMetadata?.ownDamages.shippingDamage !== null &&
            originalMetadata?.ownDamages.shippingDamage !== undefined)
        "
      >
        <span class="card__label" i18n>Expéditions de marchandises</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(originalMetadata?.ownDamages.shippingDamage) !==
                  getBooleanLabel(metadata.ownDamages.shippingDamage),
            }"
            >{{ getBooleanLabel(metadata.ownDamages.shippingDamage) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(originalMetadata?.ownDamages.shippingDamage) !==
                getBooleanLabel(metadata.ownDamages.shippingDamage) &&
              getBooleanLabel(originalMetadata?.ownDamages.shippingDamage) !==
                null &&
              getBooleanLabel(originalMetadata?.ownDamages.shippingDamage) !==
                undefined
            "
            >{{
              getBooleanLabel(originalMetadata?.ownDamages.shippingDamage)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata.ownDamages.lossOperatingIncome !== null &&
            metadata.ownDamages.lossOperatingIncome !== undefined) ||
          (originalMetadata?.ownDamages.lossOperatingIncome !== null &&
            originalMetadata?.ownDamages.lossOperatingIncome !== undefined)
        "
      >
        <span class="card__label" i18n>Perte de produit d'exploitation</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  originalMetadata?.ownDamages.lossOperatingIncome
                ) !== getBooleanLabel(metadata.ownDamages.lossOperatingIncome),
            }"
            >{{
              getBooleanLabel(metadata.ownDamages.lossOperatingIncome)
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(
                originalMetadata?.ownDamages.lossOperatingIncome
              ) !== getBooleanLabel(metadata.ownDamages.lossOperatingIncome) &&
              getBooleanLabel(
                originalMetadata?.ownDamages.lossOperatingIncome
              ) !== null &&
              getBooleanLabel(
                originalMetadata?.ownDamages.lossOperatingIncome
              ) !== undefined
            "
            >{{
              getBooleanLabel(originalMetadata?.ownDamages.lossOperatingIncome)
            }}</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>

<app-card
  class="flex-basis-100 mb-12"
  *ngIf="
    !isSectionEmpty(metadata?.assistance) ||
    !isSectionEmpty(originalMetadata?.assistance)
  "
>
  <div cardTitle i18n>Assistance</div>
  <div
    cardRows
    class="card__rows w-100"
    *ngIf="metadata?.assistance || originalMetadata?.assistance"
  >
    <div class="card__rows w-100">
      <div
        class="card__row"
        *ngIf="
          (metadata.assistance.forensicsFee !== null &&
            metadata.assistance.forensicsFee !== undefined) ||
          (originalMetadata?.assistance.forensicsFee !== null &&
            originalMetadata?.assistance.forensicsFee !== undefined)
        "
      >
        <span class="card__label" i18n>Frais forensiques</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(originalMetadata?.assistance.forensicsFee) !==
                  getBooleanLabel(metadata.assistance.forensicsFee),
            }"
            >{{ getBooleanLabel(metadata.assistance.forensicsFee) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(originalMetadata?.assistance.forensicsFee) !==
                getBooleanLabel(metadata.assistance.forensicsFee) &&
              getBooleanLabel(originalMetadata?.assistance.forensicsFee) !==
                null &&
              getBooleanLabel(originalMetadata?.assistance.forensicsFee) !==
                undefined
            "
            >{{
              getBooleanLabel(originalMetadata?.assistance.forensicsFee)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata.assistance.dataProtectionViolationFee !== null &&
            metadata.assistance.dataProtectionViolationFee !== undefined) ||
          (originalMetadata?.assistance.dataProtectionViolationFee !== null &&
            originalMetadata?.assistance.dataProtectionViolationFee !==
              undefined)
        "
      >
        <span class="card__label" i18n
          >Frais en relation avec la violation de la protection des
          données</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  originalMetadata?.assistance.dataProtectionViolationFee
                ) !==
                  getBooleanLabel(
                    metadata.assistance.dataProtectionViolationFee
                  ),
            }"
            >{{
              getBooleanLabel(metadata.assistance.dataProtectionViolationFee)
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(
                originalMetadata?.assistance.dataProtectionViolationFee
              ) !==
                getBooleanLabel(
                  metadata.assistance.dataProtectionViolationFee
                ) &&
              getBooleanLabel(
                originalMetadata?.assistance.dataProtectionViolationFee
              ) !== null &&
              getBooleanLabel(
                originalMetadata?.assistance.dataProtectionViolationFee
              ) !== undefined
            "
            >{{
              getBooleanLabel(
                originalMetadata?.assistance.dataProtectionViolationFee
              )
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata.assistance.crisisManagement !== null &&
            metadata.assistance.crisisManagement !== undefined) ||
          (originalMetadata?.assistance.crisisManagement !== null &&
            originalMetadata?.assistance.crisisManagement !== undefined)
        "
      >
        <span class="card__label" i18n
          >Gestion de crise et mesures de réputation</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  originalMetadata?.assistance.crisisManagement
                ) !== getBooleanLabel(metadata.assistance.crisisManagement),
            }"
            >{{ getBooleanLabel(metadata.assistance.crisisManagement) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(originalMetadata?.assistance.crisisManagement) !==
                getBooleanLabel(metadata.assistance.crisisManagement) &&
              getBooleanLabel(originalMetadata?.assistance.crisisManagement) !==
                null &&
              getBooleanLabel(originalMetadata?.assistance.crisisManagement) !==
                undefined
            "
            >{{
              getBooleanLabel(originalMetadata?.assistance.crisisManagement)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata.assistance.legalProtection !== null &&
            metadata.assistance.legalProtection !== undefined) ||
          (originalMetadata?.assistance.legalProtection !== null &&
            originalMetadata?.assistance.legalProtection !== undefined)
        "
      >
        <span class="card__label" i18n
          >Protection juridique lors de procédures administratives</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  originalMetadata?.assistance.legalProtection
                ) !== getBooleanLabel(metadata.assistance.legalProtection),
            }"
            >{{ getBooleanLabel(metadata.assistance.legalProtection) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(originalMetadata?.assistance.legalProtection) !==
                getBooleanLabel(metadata.assistance.legalProtection) &&
              getBooleanLabel(originalMetadata?.assistance.legalProtection) !==
                null &&
              getBooleanLabel(originalMetadata?.assistance.legalProtection) !==
                undefined
            "
            >{{
              getBooleanLabel(originalMetadata?.assistance.legalProtection)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata.assistance.cyberBlackmail !== null &&
            metadata.assistance.cyberBlackmail !== undefined) ||
          (originalMetadata?.assistance.cyberBlackmail !== null &&
            originalMetadata?.assistance.cyberBlackmail !== undefined)
        "
      >
        <span class="card__label" i18n>Cyberchantage</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(originalMetadata?.assistance.cyberBlackmail) !==
                  getBooleanLabel(metadata.assistance.cyberBlackmail),
            }"
            >{{ getBooleanLabel(metadata.assistance.cyberBlackmail) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(originalMetadata?.assistance.cyberBlackmail) !==
                getBooleanLabel(metadata.assistance.cyberBlackmail) &&
              getBooleanLabel(originalMetadata?.assistance.cyberBlackmail) !==
                null &&
              getBooleanLabel(originalMetadata?.assistance.cyberBlackmail) !==
                undefined
            "
            >{{
              getBooleanLabel(originalMetadata?.assistance.cyberBlackmail)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata.assistance.negociationFee !== null &&
            metadata.assistance.negociationFee !== undefined) ||
          (originalMetadata?.assistance.negociationFee !== null &&
            originalMetadata?.assistance.negociationFee !== undefined)
        "
      >
        <span class="card__label" i18n>Frais de négociation</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(originalMetadata?.assistance.negociationFee) !==
                  getBooleanLabel(metadata.assistance.negociationFee),
            }"
            >{{ getBooleanLabel(metadata.assistance.negociationFee) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(originalMetadata?.assistance.negociationFee) !==
                getBooleanLabel(metadata.assistance.negociationFee) &&
              getBooleanLabel(originalMetadata?.assistance.negociationFee) !==
                null &&
              getBooleanLabel(originalMetadata?.assistance.negociationFee) !==
                undefined
            "
            >{{
              getBooleanLabel(originalMetadata?.assistance.negociationFee)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata.assistance.ransomPayment !== null &&
            metadata.assistance.ransomPayment !== undefined) ||
          (originalMetadata?.assistance.ransomPayment !== null &&
            originalMetadata?.assistance.ransomPayment !== undefined)
        "
      >
        <span class="card__label" i18n>Paiement de rançon</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(originalMetadata?.assistance.ransomPayment) !==
                  getBooleanLabel(metadata.assistance.ransomPayment),
            }"
            >{{ getBooleanLabel(metadata.assistance.ransomPayment) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(originalMetadata?.assistance.ransomPayment) !==
                getBooleanLabel(metadata.assistance.ransomPayment) &&
              getBooleanLabel(originalMetadata?.assistance.ransomPayment) !==
                null &&
              getBooleanLabel(originalMetadata?.assistance.ransomPayment) !==
                undefined
            "
            >{{
              getBooleanLabel(originalMetadata?.assistance.ransomPayment)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata.assistance.insuranceSum !== undefined &&
            metadata.assistance.insuranceSum !== null) ||
          (originalMetadata?.assistance.insuranceSum !== undefined &&
            originalMetadata?.assistance.insuranceSum !== null)
        "
      >
        <span class="card__label" i18n>Somme d'assurance</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata?.assistance.insuranceSum !==
                  metadata.assistance.insuranceSum,
            }"
            >{{ metadata.assistance.insuranceSum }} CHF</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata?.assistance.insuranceSum !==
                metadata.assistance.insuranceSum &&
              originalMetadata?.assistance.insuranceSum !== null &&
              originalMetadata?.assistance.insuranceSum !== undefined
            "
            >{{ originalMetadata?.assistance.insuranceSum }} CHF</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata.assistance.generalDeductible !== undefined &&
            metadata.assistance.generalDeductible !== null) ||
          (originalMetadata?.assistance.generalDeductible !== undefined &&
            originalMetadata?.assistance.generalDeductible !== null)
        "
      >
        <span class="card__label" i18n>Franchise générale</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata?.assistance.generalDeductible !==
                  metadata.assistance.generalDeductible,
            }"
            >{{ metadata.assistance.generalDeductible }} CHF</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata?.assistance.generalDeductible !==
                metadata.assistance.generalDeductible &&
              originalMetadata?.assistance.generalDeductible !== null &&
              originalMetadata?.assistance.generalDeductible !== undefined
            "
            >{{ originalMetadata?.assistance.generalDeductible }} CHF</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>
